/** Display helpers local to the console (pure; no `@/` imports so tests can load them). */

export function formatDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Kolkata' });
}

/** Paise → compact rupees: ₹27.8 L, ₹1.2 Cr, ₹16,997. */
export function formatINRCompact(paise) {
  if (paise == null) return '—';
  const r = Number(paise) / 100;
  if (Math.abs(r) >= 1e7) return `₹${(r / 1e7).toFixed(2)} Cr`;
  if (Math.abs(r) >= 1e5) return `₹${(r / 1e5).toFixed(1)} L`;
  return `₹${Math.round(r).toLocaleString('en-IN')}`;
}

export const humanize = (s) => String(s == null ? '' : s).replace(/[._]/g, ' ');
